import { Card, Typography, Button, Row, Col, Divider, Tooltip, Space } from "antd";
import {
  WhatsAppOutlined,
  PhoneOutlined,
  MailOutlined,
  SmileTwoTone,
  UserOutlined
} from "@ant-design/icons";
import Sidebar from "../../Sidebar";
import HeaderPage from "../../HeaderPage";
import ImgHands from "../../../assets/imagens/hands.png";
import { motion } from "framer-motion";
import ImgWpp from "../../../assets/imagens/wpp_black.png";
import ImgFone from "../../../assets/imagens/telefone-icon.png";

const { Title, Text, Paragraph } = Typography;

const SucessoPedido = () => {
  return (
    <div className="flex-dashboard" style={{ background: "#f7fafc", minHeight: "100vh" }}>
      <Sidebar />
      <main>
        <HeaderPage nomeOpcao="Booking" />
        <Row
          justify="center"
          align="middle"
          style={{ minHeight: "80vh", margin: 0 }}
        >
          <Col xs={24} sm={18} md={12} lg={10}>
            <motion.div
              initial={{ opacity: 0, scale: 0.97, y: 50 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <Card
                bordered={false}
                style={{
                  borderRadius: 20,
                  boxShadow: "0 4px 32px #0066cc16",
                  padding: 0,
                  background: "#fff",
                }}
                bodyStyle={{ padding: "36px 32px 32px 32px" }}
                hoverable
              >
                <Row justify="center">
                  <Col>
                    <motion.img
                      src={ImgHands}
                      alt="Booking Sucesso"
                      width={120}
                      height={120}
                      style={{ marginBottom: 10 }}
                      initial={{ scale: 0.9 }}
                      animate={{ scale: [1, 1.08, 1] }}
                      transition={{
                        repeat: Infinity,
                        repeatType: "reverse",
                        duration: 2,
                        ease: "easeInOut",
                      }}
                    />
                  </Col>
                </Row>
                <Title
                  level={2}
                  style={{
                    textAlign: "center",
                    margin: 0,
                    color: "#1890ff",
                    letterSpacing: 1,
                  }}
                >
                  Booking Processado
                </Title>
                <Divider style={{ marginTop: 16, marginBottom: 10 }} />
                <Paragraph style={{ textAlign: "center", fontSize: 18 }}>
                  <SmileTwoTone twoToneColor="#52c41a" style={{ fontSize: 20 }} />{" "}
                  <b>Em breve, um de nossos analistas irá entrar em contato!</b>
                </Paragraph>
                <Paragraph style={{ textAlign: "center", fontSize: 16 }}>
                  Se preferir, fale conosco agora mesmo através dos nossos canais:
                </Paragraph>
                <Space
                  direction="horizontal"
                  size="large"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "20px 0 12px 0",
                  }}
                >
                  <Tooltip title="WhatsApp">
                    <Button
                      type="text"
                      shape="circle"
                      size="large"
                      icon={
                        <img
                          src={ImgWpp}
                          alt="WhatsApp"
                          width={36}
                          height={36}
                          style={{ filter: "drop-shadow(0 1px 2px #00e67699)" }}
                        />
                      }
                      href="https://wa.me/+5511940580365"
                      target="_blank"
                      style={{ background: "#e5fbee" }}
                    />
                  </Tooltip>
                  <Tooltip title="Telefone">
                    <Button
                      type="text"
                      shape="circle"
                      size="large"
                      icon={
                        <img
                          src={ImgFone}
                          alt="Telefone"
                          width={36}
                          height={36}
                          style={{ filter: "drop-shadow(0 1px 2px #2196f399)" }}
                        />
                      }
                      href="tel:+5511940580365"
                      style={{ background: "#e6eefa" }}
                    />
                  </Tooltip>
                  <Tooltip title="E-mail Central do Cliente">
                    <Button
                      type="text"
                      shape="circle"
                      size="large"
                      icon={<MailOutlined style={{ fontSize: 32, color: "#4b68af" }} />}
                      href="mailto:comercial@zarpar.net"
                      style={{ background: "#f6f7fa" }}
                    />
                  </Tooltip>
                </Space>
                <Paragraph style={{ textAlign: "center", fontSize: 16, marginBottom: 8 }}>
                  ou envie um e-mail para{" "}
                  <a
                    href="mailto:comercial@zarpar.net"
                    style={{
                      fontWeight: "bold",
                      color: "#005c9c",
                      textDecoration: "underline",
                    }}
                  >
                    Central do Cliente
                  </a>
                </Paragraph>
                <Divider style={{ margin: "18px 0 10px" }} />
                <Row justify="center">
                  <Col>
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      <UserOutlined style={{ marginRight: 5 }} />
                      Atendimento: Segunda a Sexta, das 8h às 18h
                    </Text>
                  </Col>
                </Row>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </main>
    </div>
  );
};

export default SucessoPedido;
